import { render } from "./MainNav.vue?vue&type=template&id=40ab280f"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__